export default function NotFound() {
  return (
    <section>
      <div className="flex items-center justify-center h-screen">
        <p className="text-xl md:text-3xl lg:text-4xl text-accent font-medium font-sub">
          Not Found
        </p>
      </div>
    </section>
  )
}
